// extracted by mini-css-extract-plugin
export default {"hero":"SmallHero__hero--Cf","xs":"SmallHero__xs--ZG","md":"SmallHero__md--Ql","sm":"SmallHero__sm--Az"};